<template>
<div class="chapter">
<div class="inner_page">
<a id="page_5"></a>
<h1 class="toc-title">CONTENTS</h1>
<h2 class="toc"><a href="#/xhtml/05_Acknowledgements">Acknowledgements</a></h2>
<h2 class="toc"><a href="#/xhtml/06_Introduction">Introduction</a></h2>
<h2 class="toc2"><a href="#/xhtml/07_Section1"><span class="space">Section 1:</span> Virgin Cross Country</a></h2>
<h3 class="toc3"><a href="#/xhtml/07_Section1#sec01">1.1: Class 43-High Speed Trainsets (HST)</a></h3>
<h3 class="toc3"><a href="#/xhtml/07_Section1#sec02">1.2: Class 47</a></h3>
<h3 class="toc3"><a href="#/xhtml/07_Section1#sec03">1.3: Class 86</a></h3>
<h3 class="toc3"><a href="#/xhtml/07_Section1#sec04">1.4: Class 158-Express Sprinter</a></h3>
<h3 class="toc3"><a href="#/xhtml/07_Section1#sec05">1.5: Classes 220/221</a></h3>
<h3 class="toc3"><a href="#/xhtml/07_Section1#sec06">1.5.1: Class 220-‘Voyager’</a></h3>
<h3 class="toc3"><a href="#/xhtml/07_Section1#sec07">1.5.2: Class 221-‘Super Voyager’</a></h3>
<h2 class="toc2"><span href="#/xhtml/08_Section2" title="Link target outside of Sample"><span class="space">Section 2: Virgin Trains West Coast</span></span></h2>
<h3 class="toc3"><span href="#/xhtml/08_Section2#sec08" title="Link target outside of Sample">2.1: Class 43-High Speed Trainsets (HST)</span></h3>
<h3 class="toc3"><span href="#/xhtml/08_Section2#sec09" title="Link target outside of Sample">2.2: Class 47</span></h3>
<h3 class="toc3"><span href="#/xhtml/08_Section2#sec10" title="Link target outside of Sample">2.3: Class 57/3-Thunderbird</span></h3>
<h3 class="toc3"><span href="#/xhtml/08_Section2#sec11" title="Link target outside of Sample">2.4: Class 82/1-Driving Van Trailer (DVT)</span></h3>
<h3 class="toc3"><span href="#/xhtml/08_Section2#sec12" title="Link target outside of Sample">2.5: Class 86</span></h3>
<h3 class="toc3"><span href="#/xhtml/08_Section2#sec13" title="Link target outside of Sample">2.6: Class 87</span></h3>
<h3 class="toc3"><span href="#/xhtml/08_Section2#sec14" title="Link target outside of Sample">2.7: Class 90</span></h3>
<h3 class="toc3"><span href="#/xhtml/08_Section2#sec15" title="Link target outside of Sample">2.8: Class 221 ‘Super Voyager’</span></h3>
<h3 class="toc3"><span href="#/xhtml/08_Section2#sec16" title="Link target outside of Sample">2.9: Class 390 ‘Pendolino’</span></h3>
<h2 class="toc2"><span href="#/xhtml/09_Section3" title="Link target outside of Sample"><span class="space">Section 3: Virgin Trains East Coast</span></span></h2>
<h3 class="toc3"><span href="#/xhtml/09_Section3#sec17" title="Link target outside of Sample">3.1: Class 43-High Speed Trainsets (HST)</span></h3>
<h3 class="toc3"><span href="#/xhtml/09_Section3#sec18" title="Link target outside of Sample">3.2: Class 67</span></h3>
<h3 class="toc3"><span href="#/xhtml/09_Section3#sec19" title="Link target outside of Sample">3.3: Class 82/2-Driving Van Trailer (DVT)</span></h3>
<h3 class="toc3"><span href="#/xhtml/09_Section3#sec20" title="Link target outside of Sample">3.4: Class 90</span></h3>
<h3 class="toc3"><span href="#/xhtml/09_Section3#sec21" title="Link target outside of Sample">3.5: Class 91/1</span></h3>
<h3 class="toc3"><span href="#/xhtml/09_Section3#sec22" title="Link target outside of Sample">3.6: Class 800/1-Intercity Express Train</span></h3>
<h2 class="toc2"><span href="#/xhtml/10_Section4" title="Link target outside of Sample"><span class="space">Section 4:</span> Virgin Trains – The End</span></h2>
<h2 class="toct"><span href="#/xhtml/11_Bm01" title="Link target outside of Sample">The End – The Final Trains</span></h2>
<a id="page_6"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?030cd0d4